import React, { Component } from 'react'
import { connect } from 'react-redux'
import dayjs from 'dayjs'
import './CouponPopup.scss'

import { Dialog } from "@material-ui/core";
import i18n from '../../i18n';

class CouponPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentPage: 0,
            cardsPerPage: 4,
        }
    }

    isCouponUseable = coupon => {
        const { productId } = this.props

        if (!coupon || !coupon.data) return false

        const { action } = coupon.data
        switch (action) {
            case 'AddPeriod':
            case 'DiscountAll':
            case 'DiscountPercentage':
            case 'DiscountAmount':
                {
                    const { productId: productIdArr } = coupon.data
                    if (!productId || !Array.isArray(productIdArr)) return false

                    for (let i = 0; i < productIdArr.length; i++) {
                        if (productIdArr[i] === productId) return true
                    }
                    return false
                }

            default:
                return false
        }
    }

    handleKeyPress = e => {
        if (e.key === 'Enter') {
            this.props.handleClickRegisterCouponBtn()
        }
    }

    handleSelectCoupon = coupon => {
        this.props.handleSelectCoupon(coupon)
        this.props.onClose()
    }

    handleClickPageNumber = newPage => {
        this.setState({ currentPage: newPage })
    }

    renderPagination = () => {
        const { coupons } = this.props
        let { currentPage, cardsPerPage } = this.state

        if (coupons && coupons.length > 0) {
            let maxPageCount = Math.floor((coupons.length - 1) / cardsPerPage)
            if (maxPageCount < 0) maxPageCount = 0
            if (currentPage > maxPageCount) currentPage = maxPageCount
            
            const pageNumbers = []
            for (let i = 0; i <= maxPageCount; i++) {
                const number = (
                    <div
                        className={`coupon-popup-page ${currentPage === i && 'active'}`}
                        onClick={() => (currentPage !== i) && this.handleClickPageNumber(i)}
                    >
                        {i + 1}
                    </div>
                )
                
                pageNumbers.push(number)
            
            }
            return pageNumbers
        }
    }

    render() {
        const { open, onClose, handleChangeCouponCode, handleClickRegisterCouponBtn, coupons, couponCode, value } = this.props
        const { currentPage, cardsPerPage } = this.state

        return (
            <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={"md"}>
                <div className='coupon-popup-root-container prohibit-drag'>
                    <div className='coupon-popup-container'>
                        <div className='coupon-popup-close'>
                            <img src='https://front.videomonster.com/images-u6yd72dy/web/payment/couponClose.svg' onClick={onClose} />
                        </div>
                        <div className='coupon-popoup-title'>{i18n.t("coupon.discount")}</div>
                        <div className='coupon-popup-add-area'>
                            <input
                                className='coupon-popup-add-number'
                                type='text'
                                placeholder={i18n.t("monsterpoint.input.coupon.number")}
                                value={couponCode}
                                onChange={handleChangeCouponCode}
                                onKeyPress={this.handleKeyPress}
                            />
                            <div className='coupon-popup-add-button' onClick={handleClickRegisterCouponBtn}>{i18n.t("monsterpoint.register.text")}</div>
                        </div>
                        <div className='coupon-popup-list-area'>
                            <div className='coupon-popup-list-header'>
                                <div className='item-coupon-name'>{i18n.t("coupon.coupon.name")}</div>
                                <div className='coupon-date'>{i18n.t("coupon.issuance.date")}</div>
                                <div className='coupon-expired'>{i18n.t("coupon.expired.date")}</div>
                                <div className='coupon-available'>{i18n.t("coupon.remain.count.title")}</div>
                                <div className='coupon-choice'>{i18n.t("coupon.select")}</div>
                            </div>
                            <div className='coupon-popup-list-body'>
                            {
                                coupons.length > 0 ?
                                    coupons
                                        .slice(
                                            currentPage * cardsPerPage,
                                            currentPage * cardsPerPage + cardsPerPage
                                        )
                                        .map(coupon => (
                                            <div className='coupon-popup-list-body-item'>
                                                <div className='item-coupon-name'>{coupon.name[value]}
                                                    <div className='item-coupon-des'>{coupon.description[value]}</div>
                                                </div>
                                                <div className='coupon-date'>{dayjs(coupon.createdAt).format("YY.MM.DD")}</div>
                                                <div className='coupon-expired'>{`~${dayjs(coupon.expiredAt).format("YY.MM.DD")}`}</div>
                                                <div className='coupon-available'>{`${coupon.restCount}${i18n.t("mobile.mycoupon.remain.count")}`}</div>
                                                <div className='coupon-choice-area'>
                                                    {
                                                        this.isCouponUseable(coupon)
                                                            ? (<div className='coupon-choice' onClick={() => this.handleSelectCoupon(coupon)}>{i18n.t("couponright.coupon.use")}</div>)
                                                            : (<div className='coupon-choice disable'>{i18n.t("global.cannotuse")}</div>)
                                                    }
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="empty-container">{i18n.t("mobile.mycoupon.empty")}</div>
                            }
                            </div>
                        </div>
                        <div className='coupon-popup-page-area'>
                            {this.renderPagination()}
                        </div>
                    </div>
                </div>
            </Dialog>

        )
    }
}

const mapStateToProps = state => ({
    value: state.langStore.lang
})

export default connect(mapStateToProps, null)(CouponPopup)